module.exports = __webpack_public_path__ + "img/flecha-siguiente.67888703.svg";